// @vendors
import React, { ReactNode, createContext, useContext } from 'react';

// @types
import { ICommittedCapacityContext } from '../types';

// @hooks
import { useCommittedCapacityState } from '../hooks/useCommittedCapacityState';

export const CommittedCapacityContext = createContext<ICommittedCapacityContext>({} as ICommittedCapacityContext);
CommittedCapacityContext.displayName = 'CommittedCapacityContext';

export function CommittedCapacityContextProvider({ children }: { children: ReactNode }) {
  const committedCapacityValue = useCommittedCapacityState();

  return (
    <CommittedCapacityContext.Provider value={committedCapacityValue}>
      {children}
    </CommittedCapacityContext.Provider>
  );
}

export const useCommittedCapacityContext = () => useContext(CommittedCapacityContext);
